import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["categoryButtonContainer", "breadcrumb", "serviceItem"] // ⚠️ productItemをserviceItemに変更
    static values = {
        categories: Array,
        i18n: Object
    }
    
    connect() {
        this.updateView("all")
    }

    updateView(categoryId) {
        this.renderCategoryButtons(categoryId)
        this.renderBreadcrumb(categoryId)
        this.filterServiceItems(categoryId) // ⚠️ メソッド名を変更
    }

    selectCategory(event) {
        event.preventDefault()
        const categoryId = event.currentTarget.dataset.categoryId
        this.updateView(categoryId)
    }
    
    renderCategoryButtons(parentId) {
        this.categoryButtonContainerTarget.innerHTML = ""
        
        let categoriesToShow
        if (parentId === "all") {
            categoriesToShow = this.categoriesValue.filter(cat => !cat.ancestry)
        } else {
            categoriesToShow = this.categoriesValue.filter(cat => cat.ancestry == parentId)
        }
        
        if (parentId !== "all") {
            const parentCategory = this.categoriesValue.find(cat => cat.id == parentId)
            let backButtonHtml = `<button class="btn btn-outline-success me-2 mb-2" data-action="click->service-category#selectCategory" data-category-id="${parentCategory.ancestry || 'all'}">` // ⚠️ ボタン色とデータアクション名を変更
            backButtonHtml += `&#x2190; ${this.i18nValue.back_to_parent_category}`
            backButtonHtml += `</button>`
            this.categoryButtonContainerTarget.innerHTML += backButtonHtml
        }

        categoriesToShow.forEach(cat => {
            this.categoryButtonContainerTarget.innerHTML += `<button class="btn btn-outline-success category-filter-btn me-2 mb-2" data-action="click->service-category#selectCategory" data-category-id="${cat.id}" data-category-name="${cat.name}">${cat.name}</button>` // ⚠️ ボタン色とデータアクション名を変更
        })
    }
    
    renderBreadcrumb(categoryId) {
        this.breadcrumbTarget.innerHTML = ""
        
        const topText = this.i18nValue.top
        let breadcrumbHtml = `<ol class="breadcrumb">`
        if (categoryId === "all") {
            breadcrumbHtml += `<li class="breadcrumb-item active">${topText}</li>`
        } else {
            breadcrumbHtml += `<li class="breadcrumb-item"><a href="#" data-action="click->service-category#selectCategory" data-category-id="all">${topText}</a></li>`
        }

        if (categoryId !== "all") {
            let currentCategory = this.categoriesValue.find(cat => cat.id == categoryId)
            if (currentCategory) {
                const path = [currentCategory]
                while (currentCategory.ancestry) {
                    currentCategory = this.categoriesValue.find(cat => cat.id == currentCategory.ancestry)
                    if (currentCategory) {
                        path.unshift(currentCategory)
                    } else {
                        break
                    }
                }
                
                path.forEach((cat, index) => {
                    if (index === path.length - 1) {
                        breadcrumbHtml += `<li class="breadcrumb-item active">${cat.name}</li>`
                    } else {
                        breadcrumbHtml += `<li class="breadcrumb-item"><a href="#" data-action="click->service-category#selectCategory" data-category-id="${cat.id}">${cat.name}</a></li>` // ⚠️ データアクション名を変更
                    }
                })
            }
        }
        
        breadcrumbHtml += `</ol>`
        this.breadcrumbTarget.innerHTML = breadcrumbHtml
    }

    filterServiceItems(categoryId) {
        this.serviceItemTargets.forEach(item => {
            const itemCategoryIds = JSON.parse(item.dataset.categoryIds)
            const isUncategorized = item.dataset.isCategorized === "false"

            if (categoryId === "all") {
                item.style.display = isUncategorized ? "" : "none"
            } else if (itemCategoryIds.includes(parseInt(categoryId))) {
                item.style.display = ""
            } else {
                item.style.display = "none"
            }
        })
    }
}